module.exports = __webpack_public_path__ + "img/tl.74fb99c2.png";